import React, { useEffect, useState } from 'react'
import { getImageUrl } from '../../utils/images'
import { getMigDetailsById } from '../../service/BrandsService'

import { useNavigate, useParams } from 'react-router-dom'
import { userActions } from '../../store/userState'
import { useDispatch, useSelector } from 'react-redux'
import { isEmail } from '../../helpers/string'

export const PasswordVerification = ({    setCurrentTab}) => {
  const { emiratesID: id } = useParams()
  let emiratesID
  try {
    emiratesID = atob(id) ?? id
  } catch {
    emiratesID = ''
  }
  const dispatch = useDispatch()
  const userstate = useSelector(state => state.user)
  const [currentMigratedState, setCurrentMigratedState] = useState({})


  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmError, setConfirmError] = useState("");
  const [policies, setPolicies] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    special: false,
  });
  

  const validatePassword = (password) => {
    const updatedPolicies = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
    setPolicies(updatedPolicies);

    const allValid = Object.values(updatedPolicies).every(Boolean);
    return allValid;
  };


  const handleNewPasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);

    if (!validatePassword(password)) {
      setPasswordError("Password does not meet all policies.");
    } else {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const password = e.target.value;
    setConfirmPassword(password);

    if (password !== newPassword) {
      setConfirmError("Passwords do not match.");
    } else {
      setConfirmError("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validatePassword(newPassword)) {
      setPasswordError("Password does not meet all policies.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setConfirmError("Passwords do not match.");
      return;
    }
    updateFieldValue('password', confirmPassword)
    console.log("userstates",userstate)

    setCurrentTab(3);
  };








  const updateFieldValue = (key, value) => {
    console.log(key, value)
    dispatch(userActions.updateValue({ key, value }))
    setCurrentMigratedState({ ...currentMigratedState, [key]: value })
    // console.log("currentBrandState",currentBrandState)

    console.log('currentMigratedState', currentMigratedState)
    console.log('')
  }



  return (
    <div class='align-center justify-content-center'>
      {/* ======== */}

      {/*  */}
      <div class='text-center w-100 pr-60 '>
        <img
          src={getImageUrl('login-image.svg')}
          alt='img'
          class='w-100 mb-40 d-md-none'
        />

        <h1 class='font-20 font-weight-600 my-25'>
          {/* {otpRecieved ? '' : 'Verify User'} */}
        </h1>

        <form id='forgot'>
          <div className='row'>
            <div class='col-12 col-md-8 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-lock.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label>New password</label>
                <input
                  aria-valuenow={'New password'}
                  type='password'
                   id="newPassword"
                   value={newPassword}
                   onChange={handleNewPasswordChange}
                  name='new-password'
                  class='form-control'
                   placeholder="Enter new password"
                />
                
                {passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
                <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
            <li style={{ color: policies.length ? "green" : "red" }}>
              At least 8 characters
            </li>
            <li style={{ color: policies.uppercase ? "green" : "red" }}>
              At least one uppercase letter
            </li>
            <li style={{ color: policies.lowercase ? "green" : "red" }}>
              At least one lowercase letter
            </li>
            <li style={{ color: policies.digit ? "green" : "red" }}>
              At least one digit
            </li>
            <li style={{ color: policies.special ? "green" : "red" }}>
              At least one special character
            </li>
          </ul>
              </div>
            </div>{' '}
            <div class='col-12 col-md-8 login-field align-center text-left mb-3'>
              <div class='mr-3'>
                <img src={getImageUrl('icon-lock.svg')} alt='img' />
              </div>
              <div class='form-group'>
                <label>Confirm password</label>
                <input
                  aria-valuenow={'New password'}
                  type='password'
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                 
                  name='new-password'
                  class='form-control'
                  placeholder="Confirm your password"
                />
                 {confirmError && <p style={{ color: "red" }}>{confirmError}</p>}
              </div>

            </div>
            
          </div>{' '}
          <div className="my-40 d-flex " style={{justifyContent:"space-around"}}>
                             <button type="button" className="btn btn-light prev-step px-45" onClick={() => setCurrentTab(1)}>
                               Back
                             </button>
                             <button type="button" className="btn btn-default next-step px-30"   onClick={(e) => {
                             
                             handleSubmit(e);
                             

                        
                         
                           
                           }} >
                               Next Step
                             </button>
                           </div>
        </form>
      </div>
    
    </div>
    
  )
}
